import * as React from 'react'
import {useState} from 'react'
import ModalStatus from '../components/statusModal'
import '../css/restored.css'
import AppProps from '../util/appProps'
import { getCurrentLocale } from '../util/locales'

const Restored = (props: AppProps) => {
    const [showModal, setShowModal] = useState(true)
    const toggleShowModal = () => {
        setShowModal(!showModal)
        props.history.push('/' + getCurrentLocale())
    }

    const modalData = {
        title: 'Restore Successful',
        text: 'Please check your inbox for an e-mail with additional instructions to restore your password.'
    }

    return (
        <div className="restored">
            <ModalStatus data={modalData} show={showModal} toggle={toggleShowModal}/>
        </div>
    )
}

export default Restored


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/restored.tsx